var MASK_CHAR = "#";
function applyMask(mask, text) {
    var maskFunc = function(internalText) {
        var result = "";
        var i = 0, j = 0;
        while(i < internalText.length && j < mask.length && mask.length > i){
            if (mask[j] === MASK_CHAR) {
                result += internalText[i];
                i++;
                j++;
            } else {
                result += mask[j];
                j++;
            }
        }
        return result;
    };
    if (text == null) {
        return function(internalText) {
            return maskFunc(internalText);
        };
    }
    return maskFunc(text);
}
function undoMask(mask, text) {
    var undoFunc = function(internalText) {
        var result = "";
        var i = 0;
        var delimiters = mask.split(MASK_CHAR).filter(function(delimiter) {
            return delimiter.length > 0;
        });
        delimiters.forEach(function(delimiter) {
            var delimiterIndex = internalText.indexOf(delimiter, i);
            if (delimiterIndex !== -1) {
                result += internalText.slice(i, delimiterIndex);
                i = delimiterIndex + delimiter.length;
            }
        });
        result += internalText.slice(i, mask.length);
        return result;
    };
    if (text == null) {
        return function(internalText) {
            return undoFunc(internalText);
        };
    }
    return undoFunc(text);
}

export { applyMask, undoMask };
